/** @format */

import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
  viewChild,
  ElementRef,
} from '@angular/core';

import { UtilityService } from '@shared/data-access/services';
import {
  homefieldIconSignCancelOutline,
  HomefieldIconsLibraryService,
  HomefieldIconLibraryModule,
} from '@dsg-tech/homefield-angular-icons';

import { BypassSanitizationPipe } from '@shared/utils/pipes';

@Component({
  selector: 'shared-components-tool-tip',
  templateUrl: './tool-tip.component.html',
  styleUrl: './tool-tip.component.scss',
  imports: [BypassSanitizationPipe, HomefieldIconLibraryModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(mouseenter)': 'handleToolTipPosition()',
  },
})
export class ToolTipComponent {
  private readonly utilityService = inject(UtilityService);
  private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

  readonly iconSVG = input<string>();
  readonly hmfIcon = input<string>();
  readonly textHeader = input<string>();
  readonly textBody = input<string>();

  readonly randomUUIDForHeader: string = this.utilityService.generateUUID();
  readonly randomUUIDForBody: string = this.utilityService.generateUUID();

  readonly textElement = viewChild.required<ElementRef<HTMLSpanElement>>('textElement');

  bodyWidthAtLastHover: number | null = null;

  constructor() {
    this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancelOutline]);
  }

  handleToolTipPosition() {
    if (document.body.clientWidth === this.bodyWidthAtLastHover) {
      return;
    }

    this.bodyWidthAtLastHover = document.body.clientWidth;

    const rawScreenPadding = window.getComputedStyle(document.body).getPropertyValue('--hmf-s');
    let screenPadding = Number.parseInt(rawScreenPadding, 10);
    if (Number.isNaN(screenPadding)) {
      screenPadding = 16; // fallback if homefield style is not set or is invalid for some reason
    }

    const nativeTextEl = this.textElement().nativeElement;

    nativeTextEl.style.transform = '';

    const textElementRect = nativeTextEl.getBoundingClientRect();

    if (textElementRect.left < screenPadding) {
      nativeTextEl.style.transform = `translateX(${-textElementRect.left + screenPadding}px)`;
    } else if (textElementRect.right > document.body.clientWidth - screenPadding) {
      nativeTextEl.style.transform = `translateX(${document.body.clientWidth - textElementRect.right - screenPadding}px)`;
    }
  }
}
